// Root application router and component tree.
import { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { PlanPage } from '@/features/planning';
import { OrganizePage } from '@/features/organize';
import { DashboardPage } from '@/features/dashboard';
import TodayPage from '@/features/today/pages/TodayPage';
import InboxPage from '@/features/organize/pages/InboxPage';
import '@/app/App.css';
import ErrorBoundary from '@/components/layout/ErrorBoundary';
import { LoginPage, LogoutPage } from '@/features/auth';
import PrivacyPage from '@/features/legal/PrivacyPage';
import AppLayout from '@/components/layout/AppLayout';
import NewTaskRedirect from '@/app/NewTaskRedirect';
import EditTaskRedirect from '@/app/EditTaskRedirect';
import { useT } from '@/i18n/useT';
import { useFocusDebugLogger } from '@/hooks/useFocusDebugLogger';
import { WelcomePage } from '@/features/onboarding';
import { ONBOARDING_WELCOME_PATHS } from '@/constants/onboardingRoutes';

function App() {
  const t = useT();
  useFocusDebugLogger();
  return (
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<div>{t('app.loading', 'Loading page...')}</div>}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/app" element={<Navigate to="/app/today" replace />} />
            {Object.values(ONBOARDING_WELCOME_PATHS).map((welcomePath) => (
              <Route
                key={welcomePath}
                path={welcomePath}
                element={
                  <AppLayout>
                    <WelcomePage />
                  </AppLayout>
                }
              />
            ))}
            <Route
              path="/app/today"
              element={
                <AppLayout>
                  <TodayPage />
                </AppLayout>
              }
            />
            <Route
              path="/app/plan"
              element={
                <AppLayout>
                  <PlanPage />
                </AppLayout>
              }
            />
            <Route
              path="/app/organize/:taskId?"
              element={
                <AppLayout>
                  <OrganizePage />
                </AppLayout>
              }
            />
            <Route
              path="/app/inbox"
              element={
                <AppLayout>
                  <InboxPage />
                </AppLayout>
              }
            />
            <Route
              path="/app/dashboard"
              element={
                <AppLayout>
                  <DashboardPage />
                </AppLayout>
              }
            />
            <Route path="/app/logout" element={<LogoutPage />} />
            {/* Legacy routes — redirect to today with search params for TaskModal */}
            <Route path="/new-task" element={<NewTaskRedirect />} />
            <Route path="/app/task/:taskId" element={<EditTaskRedirect />} />
            {/* Triage is nu de Inbox-tab van Organize, geen eigen pagina meer. */}
            <Route
              path="/app/triage"
              element={<Navigate to="/app/organize?tab=inbox" replace />}
            />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
